/*
 * @LastEditors: zl
 * @Date: 2025-05-28 10:05:55
 * @LastEditTime: 2025-05-29 09:50:26
 * @Email: 
 * @Description: 
 */
import layoutHeaderAside from '@/layouts/HeaderAside'
const meta = { auth: true }
export default {
  path: '/shipGoods',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: '/shipGoods/shipGoodsApply',
      name: 'shipGoodsApply',
      component: () => import('@/pages/shipGoods/shipGoodsApply.vue'),
      meta: {
        ...meta,
        title: '发货',
        // requireAuth: true
      }
    },
    {
      path: '/shipGoods/shipGoodsForm',
      name: 'shipGoodsForm',
      component: () => import('@/pages/shipGoods/shipGoodsForm.vue'),
      meta: {
        ...meta,
        title: '我要发货',
        // requireAuth: true
      }
    },
  ]
}
